import _defineProperty from "/drone/src/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { Children } from 'react';
import { extendChildrenWithProps } from './utils';
export var RADIO_GROUP_CLASS_PREFIX = 'RadioGroup';
export var RadioGroup = function RadioGroup(_ref) {
  var children = _ref.children,
      name = _ref.name,
      onChange = _ref.onChange,
      selectedValue = _ref.selectedValue,
      typographyProps = _ref.typographyProps,
      restProps = _objectWithoutProperties(_ref, ["children", "name", "onChange", "selectedValue", "typographyProps"]);

  if (Children.count(children) === 0) {
    console.error("".concat(RADIO_GROUP_CLASS_PREFIX, " should contain at least a single Radio component as a child"));
    return null;
  }

  if (!name) {
    console.error("A 'name' property must be supplied to ".concat(RADIO_GROUP_CLASS_PREFIX));
    return null;
  }

  var additionalProps = _objectSpread({
    name: name,
    onChange: onChange,
    selectedValue: selectedValue,
    typographyProps: typographyProps
  }, restProps);

  var childrenWithExtendedProps = extendChildrenWithProps(children, additionalProps);
  return React.createElement(React.Fragment, null, childrenWithExtendedProps);
};
RadioGroup.displayName = RADIO_GROUP_CLASS_PREFIX;
RadioGroup.defaultProps = {
  checked: false,
  disabled: false
};